import { useState } from "react";
import { useOptionalPlotSelection } from "../context/PlotSelectionContext";

export const usePlotOutline = (): {
  isOutlined: (id: string) => boolean;
  toggleOutline: (id: string) => void;
} => {
  const selection = useOptionalPlotSelection();
  const [localThinIds, setLocalThinIds] = useState<string[]>([]);
  const thinIds = selection?.thinOutlineIds ?? localThinIds;

  return {
    isOutlined: (id) => !thinIds.includes(id),
    toggleOutline:
      selection?.toggleOutline ??
      ((id) => {
        setLocalThinIds((previous) =>
          previous.includes(id)
            ? previous.filter((item) => item !== id)
            : [...previous, id]
        );
      }),
  };
};
